import {
  CompanyQuery,
  Plan,
  PlanContractStatus,
  ServiceStatus,
  ServiceType,
} from "@/generated/graphql_billing";
import { ReferenceData } from "@/libs/test/referencedata";
import { addMonths, subMonths } from "date-fns";
import jwt_decode, { JwtPayload } from "jwt-decode";
import { graphql, HttpResponse } from "msw";

const today = new Date();
const monthAfterToday = addMonths(today, 1);
const twoAfterToday = addMonths(today, 2);
const monthBeforeToday = subMonths(today, 1);
const twoMonthBeforeToday = subMonths(today, 2);
const threeMonthBeforeToday = subMonths(today, 3);
const fourMonthBeforeToday = subMonths(today, 4);

// Services Definition
type ServiceForMock = {
  name: string;
  type: ServiceType;
  code: string;
  status: ServiceStatus;
};

type ServicesForMock = {
  [key: string]: ServiceForMock;
};

export const companyDynamicHandler = (companyQuery: CompanyQuery) => {
  return graphql.query<CompanyQuery>(
    "company",
    ({ query, variables, request }) => {
      const authzHeader = request.headers.get("authorization");
      let userSub = "";
      // Check if the Authorization header is set
      if (authzHeader?.startsWith("Bearer ")) {
        // Get the token (the part after "Bearer ")
        const idToken = authzHeader.substring(7);
        const jwtPayload = jwt_decode<JwtPayload>(idToken);
        userSub = jwtPayload["sub"];
        console.log("logged in user sub: ", userSub);
      }

      return HttpResponse.json({
        data: companyQuery,
      });
    }
  );
};

export const companyDynamicPlanHandler = (plan: Plan) => {
  return graphql.query<CompanyQuery>(
    "company",
    ({ query, variables, request }) => {
      const authzHeader = request.headers.get("authorization");
      let userSub = "";
      // Check if the Authorization header is set
      if (authzHeader?.startsWith("Bearer ")) {
        // Get the token (the part after "Bearer ")
        const idToken = authzHeader.substring(7);
        const jwtPayload = jwt_decode<JwtPayload>(idToken);
        userSub = jwtPayload["sub"];
        console.log("logged in user sub: ", userSub);
      }

      return HttpResponse.json({
        data: {
          company: {
            ...ReferenceData.companyQuery.company,
            planContract: {
              id: "1",
              status: PlanContractStatus.Contracted,
              usingDateFrom: twoMonthBeforeToday,
              usingDateTo: null,
              appliedCoupons: [],
              plan: plan,
            },
          },
        },
      });
    }
  );
};

export const companyHandler = graphql.query<CompanyQuery>(
  "company",
  ({ query, variables, request }) => {
    // Extract the idToken, and Automatically authenticate the user if the idToken is valid
    const authzHeader = request.headers.get("authorization");
    let userSub = "";
    // Check if the Authorization header is set
    if (authzHeader?.startsWith("Bearer ")) {
      // Get the token (the part after "Bearer ")
      const idToken = authzHeader.substring(7);
      const jwtPayload = jwt_decode<JwtPayload>(idToken);
      userSub = jwtPayload["sub"];
      console.log("logged in user sub: ", userSub);
    }

    return HttpResponse.json({
      data: ReferenceData.companyQuery,
    });
  }
);
